<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">我的订单</h1>
            <div class="fv_top">
                <a class="fv_tli fv_ton" href="javascript:;" @click="$router.push({path: '/user_order', query:{status:0,showVideo:1,}})">全部</a>
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/weifukuan', query:{status:'未支付',showVideo:1,}})">待付款</a>
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/weishouhuo', query:{status:'已发货',showVideo:1,}})">待收货</a>
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/weifahuo', query:{status:'已支付',showVideo:1,}})">待发货</a>
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/weipingjia', query:{status:'待评价',showVideo:1,}})">待评价</a>
            </div>
            <p class="pd15 c9">防诈骗提示：夜樱情趣商城不会以任何理由发送连接要求您填写银行信息，谨防假冒客服电话诈骗</p>
            <public-nothing v-if="tableData.data == []"></public-nothing>
            <div class="order_list" id="glist" v-else>
                <div class="od_lst" v-for="(item,index) in tableData.data" :key="index" :data-id="item.id">
                    <!-- <a href="javascript:;"> -->
                    <div>
                        <p class="od_t">
                            <em class="left">订单号:{{item.oid}}</em>
                            <em class="od_s">{{item.status}}</em>
                        </p>
                        <div class="od_gl" v-for="(iops,ind) in item.iop" :key="ind">
                            <router-link :to="{path: '/order_detail', query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}}"  target="_blank">
                                <img :src="iops.piclink" class="od_mg">
                                <p class="od_na">{{iops.title}}</p>
                                <p class="od_atr">{{iops.sku_cn}}</p>
                            </router-link>
                            <p class="od_r">
                                <em class="c3 f10">¥</em>
                                <em class="c3">{{$fnc.toFixedZ(iops.money)}}</em>
                                <em class="c9">x{{iops.number}}</em>
                            </p>
                            <p style="text-align:right;position: absolute;right: 15px;top: 40px;">
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_review',query:{id:iops.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if=" item.status == '已完成' && (iops.status == 0 || iops.status == '0') && iops.types != 25 ">{{iops.is_review == 0 ? "待评价" : "已评价" }}</a>
                                
                                <!-- <a class="od_btn od_btnr" href="javascript:;" @click="unpaidOrder(item.id)" v-else-if="item.status == '未支付'">去支付</a> -->
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/orderrefund', query:{id:orderId,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.is_return == 1">退货中</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.types == '4' && item.status == '已支付'">{{item.groups.status == 0 ? "进行中" : item.groups.status == 1 ? "待发货" : "拼团失败" }}</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已支付' && item.types == 19">{{item.group_buy && item.group_buy.status == 1 ? "待发货" : "拼购进行中" }}</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已支付' && item.types != 14 && item.types != 13">待发货</a>
                                <!-- <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已支付' && (item.types == 14 || item.types == 13)">已预约</a> -->
                                <!-- <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '配货中'">配货中</a> -->
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && item.types != 14 && item.types != 13 && item.types != 21">{{ item.types == 9 ? "完成出行" : "确认收货" }}</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && item.types == 13">{{ "完成预约" }}</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && item.types == 14">{{ "完成服务" }}</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/detail', query:{id:item.cid,showVideo:1,title:item.title}})" v-else-if="item.status == '已完成' && item.types != 25">再次购买</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.types == '4' && item.is_pay == 1 && item.group_staus != 1">邀请好友拼单</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="(item.status == '已支付' || item.status == '已发货') && item.types != 14 && item.types != 13">{{ item.status == "已支付" ? "确认发货" : "待收货" }}</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && (item.types == 14 || item.types == 13)">待确认</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail', query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="(item.status == '已发货' || item.status == '已完成') && item.mail_oid != null && item.mail_oid != ''">查看物流</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="item.status == '拼团进行中'">拼团进行中</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="item.status==4">退货成功</a>
                                <a class="od_btn od_btnr" href="javascript:;" @click="closeOrder(orderId)"  v-if="(item.status == 1 || item.status == 2 || item.status == 3) && return_reason != ''">取消退货</a> 
                                <a class="od_btn" href="javascript:;" @click="$router.push({path: '/order_detail', query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})">详情</a>
                            </p>
                        </div>
                    </div>
                    <!-- </a> -->
                    <p class="od_ftt" style="font-size:14px;"><span style="margin-right:20px;">{{item.pay}}</span>共 {{item.number}} 件商品，合计：¥ {{$fnc.toFixedZ(item.money)}}</p>
                    <div class="od_ft">
                        <a class="od_btn od_btnr" href="javascript:;" @click="cancel_pay(item.id)" v-if="item.status == '未支付' && item.types != 18">取消支付</a>
                        <!-- <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="item.status == '未支付' && item.types == 18 && item.is_virtual == 0">竞拍支付</a> -->
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/payorder',query:{id:item.id,uid:item.uid,showVideo:1}})" v-else-if="item.status == '未支付'">去支付</a>
                        <!-- <a class="od_btn od_btnr" href="javascript:;" @click="cancel_pay(item.id)" v-if="item.status == '未支付' && item.types != 18">取消支付</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="item.status == '未支付' && item.types == 18 && item.is_virtual == 0">竞拍支付</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/payorder',query:{id:item.id,uid:item.uid,showVideo:1}})" v-else-if="item.status == '未支付'">去支付</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="unpaidOrder(item.id)" v-else-if="item.status == '未支付'">去支付</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/orderrefund', query:{id:orderId,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.is_return == 1">退货中</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.types == '4' && item.status == '已支付'">{{item.groups.status == 0 ? "进行中" : item.groups.status == 1 ? "待发货" : "拼团失败" }}</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已支付' && item.types == 19">{{item.group_buy && item.group_buy.status == 1 ? "待发货" : "拼购进行中" }}</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已支付' && item.types != 14 && item.types != 13">待发货</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已支付' && (item.types == 14 || item.types == 13)">已预约</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '配货中'">配货中</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && item.types != 14 && item.types != 13 && item.types != 21">{{ item.types == 9 ? "完成出行" : "确认收货" }}</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && item.types == 13">{{ "完成预约" }}</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && item.types == 14">{{ "完成服务" }}</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/detail', query:{id:item.cid,showVideo:1,title:item.title}})" v-else-if="item.status == '已完成' && item.types != 25">再次购买</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.types == '4' && item.is_pay == 1 && item.group_staus != 1">邀请好友拼单</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="(item.status == '已支付' || item.status == '已发货') && item.types != 14 && item.types != 13">{{ item.status == "已支付" ? "确认发货" : "待收货" }}</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-else-if="item.status == '已发货' && (item.types == 14 || item.types == 13)">待确认</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail', query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="(item.status == '已发货' || item.status == '已完成') && item.mail_oid != null && item.mail_oid != ''">查看物流</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="item.status == '拼团进行中'">拼团进行中</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_detail',query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="item.status==4">退货成功</a>
                        <a class="od_btn od_btnr" href="javascript:;" @click="closeOrder(orderId)"  v-if="(item.status == 1 || item.status == 2 || item.status == 3) && return_reason != ''">取消退货</a> 
                        <a class="od_btn" href="javascript:;" @click="$router.push({path: '/order_detail', query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})">详情</a> -->
                    </div>
                </div>
            </div>
            <div class="page" id="pager">
                <el-pagination :page-sizes="[12,24,36,48]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import Public_nothing from "@/components/order/no_order"
export default {
    components:{
        'public-nothing': Public_nothing,
    },
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        isSupplier: {
            type: Boolean,
            default: false,
        },
        isStore: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return{
            numa:1,
            list:[],
            is_friend: 0,
            status:0,
            tableData: {
                data: [],
                total: 0,
            },
            iopId:"",
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                page: 1,
                page_size: 10,
                status:0,
                type:"",
                is_friend: 0,
                id:JSON.parse(window.localStorage.getItem("user")).id ? JSON.parse(window.localStorage.getItem("user")).id : "",
            },
            sub_form: {},
            showauction: false,
            address_show: false,
            show: false,
            orderRefund:"",
            orderId:"",
            pro_status:"",
            return_reason:""
        }
    },
    mounted(){
        this.getList(1);
        this.getOrderList(JSON.parse(window.localStorage.getItem("user")).id);
    },
    methods:{
        getOrderList(id) {
            var params = {};
            params.id = id || "";
            params.is_friend = this.is_friend;
            params.status = this.$route.query.status || "";
            if (this.$route.query.mid && this.$route.query.mid != "") {
                params.is_mid = 1;
            }
            this.dialogVisible = true;
            this.LogLoading = true;
            this.$api.getOrder.getOrderLists(params).then(res => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    var arr = res.result.data;
                    arr.forEach((item,i) => {
                        item.product.forEach((n,m)=>{
                            this.orderId = n.id;
                            this.orderRefund = n.order_return;
                            this.pro_status = n.status;
                            this.return_reason = n.return_reason;
                        })
                    });
                    this.tableData.total = res.result.counts;  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.page_size = res.result.pageSize;
                    this.listLoading = false;
                }
            });
        },
        //列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getOrder.getOrderLists(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    var arr = res.result.data;
                    arr.forEach((item,i) => {
                        item.product.forEach((n,m)=>{
                            this.orderId = n.id;
                            this.orderRefund = n.order_return;
                            this.pro_status = n.status;
                        })
                    });
                    this.tableData.total = res.result.counts;  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.page_size = res.result.pageSize;
                    this.tableData.id = JSON.parse(window.localStorage.getItem("user")).id;
                    this.listLoading = false;
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
        cancel_pay(id) {
            var params = {};
            params.id = id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getOrder.cancel_pay(params).then((res) => {
                if (res.code == 200) {
                    this.$alert('取消成功', '提示', {
                        confirmButtonText: '确定',
                    }).then(()=>{
                            window.location.reload();    
                        });
                    this.$emit("openThis");
                } else {
                    // alert(res.result)
                    this.$alert(`${res.result}`, '提示', {
                        confirmButtonText: '确定',
                    }).then(()=>{
                            window.location.reload();    
                        });
                }
            });
        },
        closeOrder(id) {
            this.$confirm(`是否确认取消退货？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.getOrder.closeOrderCancel({id,uid:JSON.parse(window.localStorage.getItem("user")).id}).then((res) => {
                    if (res.code == 200) {
                        this.$alert('取消成功', '提示', {
                            confirmButtonText: '确定',
                        }).then(()=>{
                            window.location.reload();    
                        });
                    }
                });
            }).catch(() => {});
        },
        unpaidOrder(id){
            var params = {};
            params.id = id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
        }
    },
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/order/Index.vue